module.exports = __webpack_public_path__ + "media/images/integrated-payments-2-f2f1b905089a5000e6425fb18e5af572.svg";